export type SymbolSizeType = {
  readonly XS: string,
  readonly SM: string,
  readonly MD: string,
  readonly LG: string,
  readonly XL: string,
};

export type SymbolWeightType = {
  readonly SM: number,
  readonly MD: number,
  readonly LG: number,
  readonly XL: number,
  readonly XXL: number,
};

export type SymbolSizeCodeType = {
  readonly XS: string,
  readonly SM: string,
  readonly MD: string,
  readonly LG: string,
  readonly XL: string,
};

export type SymbolWeightCodeType = {
  readonly SM: string,
  readonly MD: string,
  readonly LG: string,
  readonly XL: string,
  readonly XXL: string,
};

export type SymbolStyleType = {
  readonly SIZE: SymbolSizeType,
  readonly WEIGHT: SymbolWeightType,
  readonly NEXT_SIZE_CODE: SymbolSizeCodeType,
  readonly PRIOR_SIZE_CODE: SymbolSizeCodeType,
  readonly NEXT_WEIGHT_CODE: SymbolWeightCodeType,
  readonly PRIOR_WEIGHT_CODE: SymbolWeightCodeType,
};

export const SYMBOL_STYLE: SymbolStyleType = Object.freeze({
  SIZE: Object.freeze({
    XS: '12px',
    SM: '16px',
    MD: '18px',
    LG: '24px',
    XL: '40px',
  }),
  WEIGHT: Object.freeze({
    SM: 300,
    MD: 400,
    LG: 500,
    XL: 700,
    XXL: 800,
  }),
  NEXT_SIZE_CODE: Object.freeze({
    XS: 'SM',
    SM: 'MD',
    MD: 'LG',
    LG: 'XL',
    XL: 'XL',
  }),
  PRIOR_SIZE_CODE: Object.freeze({
    XS: 'XS',
    SM: 'XS',
    MD: 'SM',
    LG: 'MD',
    XL: 'LG',
  }),
  NEXT_WEIGHT_CODE: Object.freeze({
    SM: 'MD',
    MD: 'LG',
    LG: 'XL',
    XL: 'XXL',
    XXL: 'XXL',
  }),
  PRIOR_WEIGHT_CODE: Object.freeze({
    SM: 'SM',
    MD: 'SM',
    LG: 'MD',
    XL: 'LG',
    XXL: 'XL',
  }),
});
